import { Api } from "./config/request";

export const getUploadURL = name => {
  return Api.getRequest(`miscallaneous/file-upload?fileName=${name}`);
};

export const FileUpload = {
  getUploadURL
};
